<template>
  <div style="overflow: hidden;">
    <van-dropdown-menu
      v-if="false"
      direction="down"
      style="flex-direction: row;"
    >
      <van-dropdown-item
        v-model="selectValue"
        :disabled="readonly"
        :options="selectOptions"
        :title="selectTitle"
        get-container="body"
      />
    </van-dropdown-menu>
    <div
      @click="handleOpenDatePicker"
      style="border-bottom: 1px solid #c7c7c7; padding: 5px 15px;"
    >
      <span v-bind:class="classObject">{{ selectTitle }}</span>
    </div>
    <van-popup
      v-if="!readonly"
      v-model="showPicker"
      round
      get-container="body"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { DropdownMenu, DropdownItem, Popup, Picker } from "vant";
export default {
  name: "dropdown-menu",
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    labelFormat: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },
  data() {
    return {
      showPicker: false,
    };
  },
  computed: {
    classObject() {
      return { "clr-grey": !this.$props.value };
    },
    columns() {
      return this.selectOptions.map((it) => it.text);
    },
    selectValue: {
      get() {
        const int = Number.parseInt(this.$props.value);
        return isNaN(int) ? null : int;
      },
      set(value) {
        this.$emit("change", `${value}`);
      },
    },
    selectOptions() {
      const { options } = this.$props;
      if (!Array.isArray(options) || !options.length) {
        return [];
      }
      return options.map(({ order, format, text }) => {
        const label = this.getLabel(format, text);
        return { value: order, text: label };
      });
    },
    selectTitle() {
      const value = this.selectValue;
      if (value) {
        const option = this.selectOptions.find((it) => it.value === value);
        if (option) {
          return option.text || "";
        }
      }
      return this.$props.placeholder;
    },
  },
  methods: {
    getLabel(format, text) {
      return this.$props.labelFormat(format, text);
    },
    onConfirm(text, index) {
      console.log(text, index);
      const option = this.selectOptions[index];
      const value = option ? `${option.value}` : "";
      this.$emit("change", `${value}`);
      this.showPicker = false;
    },
    handleOpenDatePicker() {
      if (this.$props.readonly) {
        return;
      }
      this.showPicker = true;
      // if (this.$props.value) {
      //   this.date = new Date(this.$props.value);
      // } else {
      //   this.date = new Date();
      // }
    },
  },
};
</script>
<style scoped>
.van-dropdown-menu__title.van-dropdown-menu__title--down,
.van-dropdown-menu__title {
  flex: 1 1 0%;
  margin: 5px;
}
</style>
